import Vue from 'vue'
import queryString from 'query-string'
import {
    isIos,
    isMobile,
    isWechat,
    isAndroid,
    isDesktop,
    isIENotIncludeEdge,
    getRequest
} from '@/utils'
import request from '@/utils/request'
import { getUserInfo } from '@/api/chat'

/**
 * 公司 Code
 * c for dev:
 */
function getCompanyCode () {
    return queryString.parse(location.search).c
}

/**
 * 渠道 ID，一个公司可存在多个渠道
 * e for dev: WzJv5Ehut5VpwAqfUDbE8m
 */
function getEntryKey () {
    return queryString.parse(location.search).e
}

/**
 * oauth 授权code
 */
function getCode () {
    return queryString.parse(location.search).code
}


/**
 * theme 主题
 */
function getTheme () {
    return queryString.parse(location.search).theme
}

export default new Vue({
    // global data
    data () {
        return {
            isWechat: isWechat(),
            isMobile: isMobile(),
            isIos: isIos(),
            isAndroid: isAndroid(),
            isDesktop: isDesktop(),
            isIENotIncludeEdge: isIENotIncludeEdge(),
            chatSource: getRequest().client?getRequest().client: 'h5',
            uid: '',
            unique_id: '',
            companyCode: getCompanyCode(),
            entryKey: getEntryKey(),
            code: getCode(),
            theme: getTheme(),
            company: {
                name: '',
                logo: ''
            },
            robot: {},
            humanUsers: {}, // 人工客服属于自己的头像
            currentHumanUser: null, // 当前接待的客服
            hotWords: {}, //热门
            backupUserAvatar: '', // 客服兜底头像，当人工客服未设置个人头像时，使用该头像
            isSocketConnected: false,
            isWechatJSSDKReady: false,
            isWechatJSSDKError: false,
            isVoiceRecording: false,
            isWaitResponse: false, //判断是否正在输入
            isIphonex: false, // 通过是否支持 safe-area-inset-bottom 判断
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        }
    },
    methods: {
        setUid (uid) {
            this.uid = uid
            request({
                url: 'chat/user',
                method: 'post',
                data: {
                    chat_user_id: uid,
                    userid: getRequest().userid || '',
                    inline: !!getRequest().inline,
                    e:getRequest().e
                }
            })
        },
        setCompany (company) {
            this.company = company
        },
        setHumanUsers (users) {
            this.humanUsers = users
        },
        getCurrentHumanUser () {
            getUserInfo(this.uid).then(data => {
                this.currentHumanUser = data
            }).catch(() => {
                this.currentHumanUser = null
            })
        },
        setRobot (robot) {
            this.robot = robot
        },
        setHotWords (hotWords) {
            this.hotWords = hotWords
        },
        setBackupUserAvatar (avatar) {
            this.backupUserAvatar = avatar
        },
        setGlobalSocketConnected (status) {
            this.isSocketConnected = status
        },
        setGlobalVoiceStatus (isRecording) {
            this.isVoiceRecording = isRecording
        },
        setUniqueId (unique_id) {
            this.unique_id = unique_id
        },
        windowResize () {
            this.windowHeight = window.innerHeight
            this.windowWidth = window.innerWidth
        },
        clearCode () {
            this.code = ''
        }
    },
    created () {
        window.addEventListener('resize', this.windowResize, false)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.windowResize, false)
    }
})
